module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA80lEQVQ4T63TTyvEURTG8c+JJFkofzZkY2Fr5U2w8CpsbLGThWaBvAMvw4aFxNpOKVbK/9hSSke3fjNNYmbMuHU3t+f5nuece2/ocUWPfpGZwxjtEvRcAI8V4AGfHYIGMY7LAijGc0xgNSJOW0EycwHbuMZcAVxhHotYxwH2IuK1GZSZU9goJmzhAod1QDl8xzQ2MYsajtCPJazhDDsRcZ+ZkzhuACLirVTMzKEqzQpuMYAR7OIkIj4q3c+AeuzMnMEyCng/Iu6+tdQa0O42fm2hnbEp4f8luCmzq3anAYquDy/1pzz2F2eT9qn3z9Rl5YbtC6xFdG7VPSyCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/email.png
// module id = maZZ
// module chunks = 1